import { createContext, useContext } from "react";

export interface ShellNav {
  /** Nav item id currently selected in the rail, e.g. "dashboard", "user_grades". */
  selectedItemId: string;
  selectItem: (id: string) => void;
}

const ShellNavContext = createContext<ShellNav>({
  selectedItemId: "",
  selectItem: () => {},
});

export const ShellNavProvider = ShellNavContext.Provider;

/**
 * Read the rail's current selection from inside a program view.
 *
 * Context rather than props on purpose: the program views must stay mounted
 * while the selection changes. analytics.tsx fires ~35 thunks from a `[]`
 * useEffect, so anything that remounts it refires all of them.
 */
export const useShellNav = () => useContext(ShellNavContext);

export default ShellNavContext;
